<lib-gung-calendar-view
  [calendarItems]="calendarItemsList"
  [enableCreateItem]="true"
  (createItemEvent)="createActivity($event)"
  [enableChangeDate]="true"
  (changeDateEvent)="changeActivityDate($event)"
  [enableDragDropChangeDate]="true"
  (dragDropEvent)="changeActivityDate($event)"
  [weekView]="weekView"
></lib-gung-calendar-view>